import type { Step } from "react-joyride";

export const meetingPdfPreviewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງເນື້ອຫາບັນທຶກການປະຊຸມໃນຮູບແບບພ້ອມພິມ ຫຼື ບັນທຶກເປັນ PDF.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="meeting-pdf-header"]',
    content:
      "ກັບໄປບັນທຶກການປະຊຸມ ຫຼື ພິມ/ບັນທຶກເປັນ PDF. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="meeting-pdf-content"]',
    content:
      "ເນື້ອຫາບັນທຶກການປະຊຸມທີ່ຈະຖືກພິມ ຫຼື ດາວໂຫຼດເປັນ PDF.",
    placement: "top",
  },
];
